import React from "react";
import { FormControlWrapper } from "../FormControlWrapper";
import { FormControlOutline } from "../FormControlWrapper/FormControlOutline";
import { splitFormControlWrapperProps } from "../FormControlWrapper/helpers";
import {
  OfficeSelectorInputProps,
  OfficeSelectorInputPropsWithFormControl
} from "./OfficeSelectorInput.types";
import { SelectOffices } from "./SelectOffices";

const OfficeSelectorInputInput = (props: OfficeSelectorInputProps) => {
  const {
    onChange,
    offices = [],
    defaultValue,
    disabled,
    showSelectedLabel = true,
    allowClear = true,
    triggerClassName,
    multiselect = false,
    splitView = false,
    withApply = false,
    trigger,
    placeholder = "Select an office",
    contentWidth,
    variant = "default",
    inputClassName,
    unselectableOfficeIds,
    unselectableOfficeReason,
    selectableOfficeIds,
    ...rest
  } = props;

  return (
    <SelectOffices
      onChange={onChange || (() => {})}
      offices={offices}
      defaultValue={defaultValue}
      disabled={disabled}
      showSelectedLabel={showSelectedLabel}
      allowClear={allowClear}
      triggerClassName={triggerClassName || inputClassName}
      multiselect={multiselect}
      splitView={splitView}
      withApply={withApply}
      trigger={trigger}
      placeholder={placeholder}
      contentWidth={contentWidth}
      variant={variant}
      unselectableOfficeIds={unselectableOfficeIds}
      unselectableOfficeReason={unselectableOfficeReason}
      selectableOfficeIds={selectableOfficeIds}
    />
  );
};

export const OfficeSelectorInput = React.forwardRef<
  React.ComponentRef<typeof FormControlWrapper>,
  OfficeSelectorInputPropsWithFormControl
>((props, ref) => {
  const [wrapperProps, inputProps] = splitFormControlWrapperProps(props);
  const { disableOutline, ...restInputProps } = inputProps;

  return (
    <FormControlWrapper
      variant={"unstyled"}
      wrapperClassName={"py-0"}
      enableSlotsInputFocus
      ref={ref}
      {...wrapperProps}
    >
      <OfficeSelectorInputInput {...restInputProps} />
      {disableOutline !== true && <FormControlOutline />}
    </FormControlWrapper>
  );
}) as (
  props: OfficeSelectorInputPropsWithFormControl & {
    ref?: React.Ref<React.ComponentRef<typeof FormControlWrapper>>;
  }
) => React.ReactElement;
